<template>
  <div>
    <el-alert
      v-if="sForm.ad_status === 3"
      style="margin-bottom: 10px;"
      :title="errorTip"
      type="error">
    </el-alert>
    <div class="m_context plr">
    <el-row>
      <el-col :span="24">
        <el-form ref="sForm" :model="sForm" label-width="80px" :rules="editRules">
          <input type="hidden" v-model="sForm.ad_id"/>
          <!--广告名称-->
          <el-form-item :label="$t('advert.name')" prop="ad_title">
            <el-input v-model="sForm.ad_title"></el-input>
          </el-form-item>

          <!--广告类型-->
          <el-form-item :label="$t('advert.classify')" prop="ad_type">
            <el-select v-model="sForm.ad_type" class="w_33" :placeholder="$t('lin_global.qxzlx')">
              <el-option v-for="item,index in adTypeList" :key="item.adtypeId" :label="item.adtypeName" :value="item.adtypeId"></el-option>
            </el-select>
          </el-form-item>

          <!--广告位置-->
          <el-form-item :label="$t('advert.position')" prop="ad_position">
            <el-select  class="w_33" v-model="sForm.ad_position" :placeholder="$t('app_selectPlayPlace')">
              <el-option :label="$t('advert.positionSub.banner')" value="0"></el-option>
              <el-option :label="$t('advert.positionSub.starPage')" value="1"></el-option>
              <el-option :label="$t('app_appadv')" value="3"></el-option>
              <!--<el-option label="个人中心banner" value="2"></el-option>-->
            </el-select>
          </el-form-item>

          <!-- =========-->
          <!-- 跳转类型-->
          <!-- =========-->
          <el-form-item :label="$t('advert.jumpType')">
            <el-radio-group v-model="sForm.ad_Urltype">
              <el-radio :label="'0'">{{$t('advert.jumpTypeSub.net')}}</el-radio>
              <el-radio :label="'1'" >{{$t('advert.jumpTypeSub.appStore')}}</el-radio>
            </el-radio-group>
          </el-form-item>


          <!-- 当跳转类型为应用市场时,ad_url 则为下拉框选择应用对应的url -->
          <el-form-item v-if="sForm.ad_Urltype === '1'" :label="$t('advert.app')" prop="ad_url">
            <!--<el-select v-model="sForm.ad_url" placeholder="请选择应用">-->
            <!--<el-option label="首页banner" value="0"></el-option>-->
            <!--</el-select>-->
            <el-button v-if="appName" size="mini" @click="choiceAppVisible = true">{{appName}}</el-button>
            <el-button v-else size="mini" @click="choiceAppVisible = true">{{$t('app_sapp')}}</el-button>
          </el-form-item>

          <!-- 当跳转类型为跳转时,ad_url则输入跳转的url -->
          <el-form-item v-if="sForm.ad_Urltype === '0'" :label="$t('advert.url')" prop="ad_url">
            <el-input v-model="sForm.ad_url"></el-input>
          </el-form-item>
          <!-- =========-->
          <!-- 跳转类型 end-->
          <!-- =========-->

          <el-form-item :label="$t('advert.channel')" prop="ad_channel">
            <!--<el-select v-model="sForm.ad_channel" :placeholder="$t('mao_global.tip.pleaseSelect')+$t('advert.channel')" prop="ad_channel">-->
              <!--<el-option v-for="item in channelList" :label="item.mechanismname" :value="item.mechanismid"></el-option>-->
            <!--</el-select>-->

            <MechanismSelector :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>
          </el-form-item>

          <el-form-item :label="$t('advert.ableDate')">
            <el-col :span="11">
              <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd hh:mm" :picker-options="pickerOptions0" :placeholder="$t('advert.beginDate')" v-model="sForm.ad_start_date" style="width: 100%;"></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd hh:mm" :picker-options="pickerOptions1" :placeholder="$t('advert.endDate')" v-model="sForm.ad_start_end" style="width: 100%;"></el-date-picker>
            </el-col>
          </el-form-item>


          <el-form-item :label="$t('advert.contentImg')" prop="ad_imgUrl">

            <div  v-loading='adUlld' style="padding:10px;">
              <div v-if='isscale'>
                <croppa style="zoom:0.5;padding-top:38px;" :placeholder-font-size="30" :placeholder="$t('app_spic')" :width='360' :height='psize' :prevent-white-space="true" iinitial-image="dfImg" :remove-button-color="'#409EFF'" v-model="croppa">
                    <img crossOrigin="anonymous" :src="dfImg"
                    slot="initial">
                </croppa>
                <el-button size="" @click="upload">{{$t('app_upload')}}</el-button>
                <p style="color:#AAAEBA;margin-top:8px;width:700px;background:none;">{{sizeTip}}</p>
              </div>  
              
              <el-upload
                v-else
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :before-upload="upload1"                
                ffile-list="fileList">
                <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
                <div slot="tip" class="el-upload__tip">{{getImgName()}}</div>
                <div slot="tip">
                  <img style="width: 20%" v-if="!isscale&&sForm.ad_imgUrl" :src="$host+sForm.ad_imgUrl" />
                </div>
              </el-upload>

              <el-checkbox v-model="isscale" @change="scaleChange">{{$t('app_propcut')}}</el-checkbox>
            </div>            

            <!-- <el-col :span="6">
              <vue-core-image-upload
                id="vue-coreUpload"
                class="btn btn-primary"
                crop="local"
                :cropRatio="ratio"
                @imageuploaded="imageuploaded"
                inputOfFile="file"
                :max-file-size="5242880"
                :text="$t('app_spic')"
                :url="imgUploadUrl" >
              </vue-core-image-upload>
              <p style="color:#AAAEBA;margin-top:8px;width:700px;background:none;">{{sizeTip}}</p>
            </el-col>
            <el-col :span="18">
              <el-button type="danger" size="mini" @click="resetImg" style="display: inline-block;"><i class="el-icon-delete" style="margin-right: 10px;"></i>{{$t('advert.reset')}}</el-button>
            </el-col> -->
          </el-form-item>

          <!-- <el-form-item v-if="isShowPP" label="">
            <el-col :span="24">
              <img :src="imageUrl +sForm.ad_imgUrl" />
            </el-col>
          </el-form-item> -->

          <el-form-item>
            <el-button @click="cancelEdit">{{$t('mao_global.btn.cancel')}}</el-button>

            <el-button v-if="sForm.ad_id === '0'" type="success" @click="createAdvert">{{$t('mao_global.btn.add')}}</el-button>
            <template v-else>
              <el-button v-if="sForm.ad_status == 0 || sForm.ad_status == 3 || sForm.ad_status == 4 || sForm.ad_status == 5" type="primary" @click="updateAdvert">{{$t('mao_global.btn.update')}}</el-button>

            </template>

          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    </div>

    <!--选择应用摸态框-->
    <el-dialog :title="$t('app_sapp')" :visible.sync="choiceAppVisible">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item :label="$t('advert.appName')">
          <el-input :placeholder="$t('app_iappnamesrch')" v-model="tmp_appName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getAppListByName">{{$t('mao_global.tip.search')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="appList" @cell-click="choiceAppRecord">
        <el-table-column property="appName" :label="$t('advert.appSub.name')"></el-table-column>
        <el-table-column property="appCategoryName" :label="$t('advert.appSub.classify')"></el-table-column>
        <el-table-column property="chekcTime" :label="$t('advert.appSub.uploadTime')" :formatter="dateFormat"></el-table-column>
        <el-table-column property="appVersion" :label="$t('advert.appSub.version')"></el-table-column>
      </el-table>
      <paging style="float:left;" :rdata="pagingData" :action="pAction" arraySize="[5,8]" ></paging>
      <div slot="footer" class="dialog-footer">

        <el-button @click="choiceAppVisible = false">{{$t('mao_global.btn.cancel')}}</el-button>
        <!--<el-button type="primary" @click="choiceAppVisible = false">确 定</el-button>-->
      </div>
    </el-dialog>

  </div>

</template>
<style scoped>
  #vue-coreUpload .g-core-image-upload-form {
    height: 160px !important;
  }
  .g-core-image-upload-btn{
    cursor: pointer;
  }
  .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c4c4c4;
    color: #1f2d3d;
    margin-top:8px;
    padding: 4px;
    font-size: 12px;
    border-radius: 4px;
  }
  .btn:hover{color:#20a0ff;border-color:#20a0ff;}

  .btn--small {
    padding: 4px;
    font-size: 12px;
    border-radius: 4px;
  }
  .avatarF{height:auto;width:100%;display:block;}

  /*.vue-coreUpload {*/
    /*background: red;*/
  /*}*/
</style>
<script>
  import axios from 'axios'
  import mm from 'moment'
  import { baseurl,url } from '../../api/url'
  import VueCoreImageUpload from 'vue-core-image-upload'
  import MPage from '@/components/global/paging.vue'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import jq from 'jquery'
  export default{
    components: {
      MechanismSelector,
      'vue-core-image-upload': VueCoreImageUpload,
      paging: MPage
    },
    data(){
      var that = this
      return {
        isscale: true,
        mechanismData: '',
        pagingData: {
          total: null,
          pageSize: 5,
          currentPage: 1
        },
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      	// 如果审核不通过,提示的信息
        errorTip: '',
        croppa: {},
        dfImg: '', //https://zhanziyang.github.io/vue-croppa/static/500.jpeg
        ratio: '12:5',
      	imageUrl: url,
        choiceAppVisible: false,
      	// 判断广告详情中的图片,是否新增或编辑状态
      	isCreateType: true,
        temPreview: null,
        editRules: {
          ad_title:[
            { required: true, message: this.$t('app_adnamenotnull'), trigger:'blur'} //'名称不能为空'
          ],
          ad_url:[
            { required: true, message: this.$t('mao_global.tip.notBlank'), trigger:'blur'}
          ],
          ad_channel:[
            { required: true, message: this.$t('app_plslchannel'), trigger:'blur'}
          ],
          ad_position:[
            { required: true, message: this.$t('app_plslplpos'), trigger:'blur'}
          ],
          ad_type:[
            { required: true, message: this.$t('app_plsltype'), trigger:'blur'}
          ],
          ad_imgUrl:[
            { required: true, message: this.$t('app_uploadPic'), trigger:'blur'}
          ]

        },
        // 渠道商列表
        channelList: '',
        tmp_appName: '',
        appName: '',
        appList: null,
        adTypeList: null,
        adUlld: false,
        sForm: {
        	ad_id: this.$route.params.id,
          ad_imgUrl: null,
          ad_title: null, // 广告标题
          ad_type: '', // 广告类型
          ad_url: null, // 跳转链接
          ad_Urltype: '0',
          ad_start_date: null, // 开始时间
          ad_start_end: null, // 结束时间
          ad_content: null, // 广告内容
          ad_position: '0', // 广告位置: 0 首页banner 1 启动界面 2个人中心
          ad_playTimes: '', // 播放时长
          ad_channel: ''
        },
        pAction : {
          handleSizeChange (v) {
            that.pagingData['pageSize'] = v
            that.pagingData['currentPage'] = 1;
            that.getAppList()
          },
          handleCurrentChange (v) {
            that.pagingData['currentPage'] = v;
//
            console.log(JSON.stringify(that.pagingData,null,4))
            that.getAppList()
          }
        }
      }
    },
    computed: {
      psize () {
        if (this.sForm.ad_position == 0) {
          // banner 720 300
          return '150'
        } else {
          // launch 720 980
          return '490'
        }
      },
      isShowPP () {
        // sForm.ad_id && sForm.ad_imgUrl
        return this.sForm.ad_imgUrl?this.sForm.ad_imgUrl:false
      },
      sizeTip () {
        var ps = this.sForm.ad_position
        var w = this.$t('app_csulpicbsis')
        if (!ps) return ''
        if (ps === '0') {
          return w + '720*300'
        } else if (ps === '1') {
          return w + '720*980'
        }
      },
      imgUploadUrl () {
        return this.$imgUploadUrl
      }
    },
    mounted(){
      
      if (this.$route.path.search('edit') != -1) {
        this.isscale = false
      }      

      if(!this.sForm.ad_id) {
        this.sForm.ad_id = '0'
      }
    	var that = this
//      that.fetchChannel()
      that.fetchData()
    },
    watch: {
      choiceAppVisible (val) {
      	var that = this
      	that.tmp_appName = ''
        
        that.getAppList()
      },
      'sForm.ad_start_date' (val) {

        var that = this
        if (val) {

      		// 条件1: 如果选择了开始时间,且结束时间不为空
          // + 条件2: 开始时间改变时, 且大于结束时间 , 则需要把结束时间置为空
          if (that.sForm.ad_start_end) {
              if (new Date(val).getTime() > new Date(that.sForm.ad_start_end).getTime()) {
                that.sForm.ad_start_end = ''
              }
          }
          that.pickerOptions1 = {
            disabledDate(time) {
              // var vl = time.getTime() < new Date(val).getTime() + 8.64e7;
              var vl = time.getTime() < new Date(val).getTime() + 8.64e7;
              return vl
            }
          }
        }

      },
    	'sForm.ad_Urltype' (val) {
    		var that = this
        that.sForm.ad_url = ''
        //that.appName = ''
        that.tmp_appName = ''
      },
      'sForm.ad_position' (val) {
      	var that = this
      	if (val === '0') {
      		that.ratio = '12:5'
        } else if (val === '1') {
      		that.ratio = '34:49'
        } else {
          that.ratio = '12:5'
        }
      }
    },
    methods:{
      getImgName () {
        var arr = this.sForm.ad_imgUrl.split('/')        
        return arr[arr.length - 1]
      },
      scaleChange () {
        this.sForm.ad_imgUrl = ''
        // this.hBlur()
      },
      hBlur () {
        this.$refs['sForm'].validate((valid) => {
          if (valid) {
          } else {
            return false
          }
        })
      },
      uploadRqs (file,type) {
        var _this = this
        this.adUlld = true
        axios.post(this.$adUlUrl , {
          file: file,
          flix: type
        })
        .then(function (res) {
          _this.adUlld = false
          if (res.data.status == 200) {
            _this.sForm.ad_imgUrl = res.data.data
            _this.hBlur()
          } else {
            _this.$message.error(res.data.message)
            _this.sForm.ad_imgUrl = ''
          }              
        })
        .catch(function (res) {
          _this.adUlld = false
          _this.sForm.ad_imgUrl = ''
          _this.$message.error(this.$t('app_picUlError'))
        });
      },
      upload () {
        var _this = this
        if (!this.croppa.hasImage()) {
          this.$message(this.$t('app_uploadPic'))
          return
        }                
        this.croppa.generateBlob((blob) => {
          this.blobToDataURL(blob, img => {            
            _this.uploadRqs(img, blob.type.replace('image/', ''))      
          })
        })
      },
      upload1 (file) {
        var _this = this
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload  = function(event){
          let img_base64 = this.result          
          _this.uploadRqs(img_base64, file.type.replace('image/', ''))      
        }        
        return false
      },
      // Blob转image
      blobToDataURL(blob, callback) {
          var a = new FileReader()
          a.onload = function (e) { callback(e.target.result) }
          a.readAsDataURL(blob)
      },
      imageuploaded (res) {
//      	console.log(JSON.stringify(res))
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.sForm.ad_imgUrl = res.data
        //  this.temPreview = URL.createObjectURL(file.raw)
        }
      },
      choiceAppRecord (v) {
        var that = this        
        setTimeout(function(){
          that.appName = v['appName']
          that.sForm.ad_url = v['applicationid']          
          that.choiceAppVisible = false
        }, 300)


      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD')
      },
      getAppListByName () {
      	var that = this
        that.pagingData['currentPage'] = 1;

        that.getAppList(that.tmp_appName)
      },
    	getAppList (name) {
    		var that = this
        var aName = that.tmp_appName || ''
//        if (name && name !== '') aName = name

        this.$getDistributeAppList1(aName, '', that.pagingData.pageSize, that.pagingData.currentPage, localStorage.mechanismId, '', '', (res) => {
          //console.log(res)
          if (res.status === 200) {
            //this.total = res.total
            that.appList = res.data
          if (res.total) that.pagingData['total'] = res.total

          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
        })

  

      },
    	resetImg () {
    		var that = this
        that.sForm.ad_imgUrl=null
        that.isCreateType = true
      },
      OnUploadSuccess (res, file) {
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.sForm.ad_imgUrl = res.data
          this.temPreview = URL.createObjectURL(file.raw)
        }
      },
      baseEditAdvert (url,msg) {
        var that = this


        function FormatDate(fmt,date)
        { //author: meizz
          var o = {
            "M+" : date.getMonth()+1,                 //月份
            "d+" : date.getDate(),                    //日
            "h+" : date.getHours(),                   //小时
            "m+" : date.getMinutes(),                 //分
            "s+" : date.getSeconds(),                 //秒
            "q+" : Math.floor((date.getMonth()+3)/3), //季度
            "S"  : date.getMilliseconds()             //毫秒
          };
          if(/(y+)/.test(fmt))
            fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
          for(var k in o)
            if(new RegExp("("+ k +")").test(fmt))
              fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
          return fmt;
        }


        this.$refs['sForm'].validate(function (result) {

          if(result){
            if (!that.sForm.ad_imgUrl || that.sForm.ad_imgUrl === "") {
//              that.$message.error("请上传广告图片")
              that.$message.error(this.$t('app_spic'))
              return;
            }

            function getFormatDate(arg) {
              if (arg == undefined || arg == '') {
                return '';
              }

              var re = arg + '';
              if (re.length < 2) {
                re = '0' + re;
              }

              return re;
            }

            function addDate(date, days) {
              if (days == undefined || days == '') {
                days = 1;
              }
              var date = new Date(date);
              date.setDate(date.getDate() + days);
              var month = date.getMonth() + 1;
              var day = date.getDate();
              return date.getFullYear() + '-' + getFormatDate(month) + '-' + getFormatDate(day);
            }

            if (!that.sForm.ad_start_date || that.sForm.ad_start_date === "") {
//              that.$message.error("请选择开始时间")
              that.$message.error(this.$t('app_slsttime'))
              return;
            }
            else {
              that.sForm.ad_start_date = FormatDate('yyyy-MM-dd', new Date(that.sForm.ad_start_date))
            }

            if (!that.sForm.ad_start_end || that.sForm.ad_start_end === "") {
              that.$message.error(this.$t('app_slendtime'))
              return;
            }
            else {
              // that.sForm.ad_start_end = addDate(that.sForm.ad_start_end, 1)
              that.sForm.ad_start_end = FormatDate('yyyy-MM-dd', new Date(that.sForm.ad_start_end))
            }

            console.log(JSON.stringify(that.sForm, null, 2))

            // 验证通过,调用module里的setUserInfo方法 add.do
            axios.post(`${baseurl}/admanage/` + url,that.sForm).then(res=>{
              if (res.data && res.data.status && res.data.status === 200) {
                that.$message(msg)
                that.$router.push({path: "/advert-list"})
              }
            })
          }
        }.bind(that));

      },
      updateAdvert () {
        var that = this
        that.baseEditAdvert('edit.do',this.$t('app_updateSuccess'))
      },
      createAdvert () {
        var that = this
        // that.sForm.ad_start_end = that.sForm.ad_start_end + 8.64e7
        // that.sForm.ad_start_date = that.sForm.ad_start_date + 8.64e7
        // console.log(JSON.stringify(that.sForm))
        // return;
        that.baseEditAdvert('add.do',this.$t('app_addsc'))
      },
      cancelEdit () {
      	var that = this
        that.$router.push({path: "/advert-list"})
      },
      // 获取渠道商列表
      fetchChannel () {
      	var that = this
        axios.post(`${baseurl}/mechanism/list.do`,{'page':1, rows: 10000}).then(res=>{
          that.channelList = res.data.data
        })
      },
      // 查询数据
      fetchData () {
      	var that = this
        if (that.sForm.ad_id === '0') {
          that.isCreateType = false
          that.mechanismData = {
              value: '',
              callback (value) {
                that.sForm.ad_channel = value
              }
            }
        } else {
          
          axios.post(`${baseurl}/advertisement/detail.do`,{'id':that.sForm.ad_id}).then(res=>{
            
            var obj = res.data.data;
            
            if(!obj) return
            that.dfImg =  that.imageUrl + obj['adImgurl']
            
            that.sForm = {
              ad_id: obj['adId'],
              ad_imgUrl: obj['adImgurl'],
              ad_status: obj['adStatus'],
              ad_title: obj['adTitle'], // 广告标题
              ad_type: obj['adType'], // 广告类型
              ad_url: obj['adUrl'], // 跳转链接
              ad_Urltype: obj['adUrltype'],
              ad_start_date: obj['adStartDate'].split(' ')[0], // 开始时间
              //ad_start_date: '',
              ad_start_end: obj['adStartEnd'].split(' ')[0], // 结束时间
              //ad_start_end: '',
              ad_content: obj['adContent'], // 广告内容
              ad_position: obj['adPosition'], // 广告位置: 0 首页banner 1 启动界面 2个人中心
              ad_playTimes: obj['adPlayTimes']|| '', // 播放时长
              ad_channel: (obj['pMechanism']) ? obj['pMechanism']['mechanismid'] : '' // 渠道商
            }


            that.mechanismData = {
              value: (obj['pMechanism']) ? obj['pMechanism']['mechanismname'] : '',
              callback (value) {
                that.sForm.ad_channel = value
              }
            }
            
          ///// 
            that.appName = obj.appName

            if (obj['reFuseReason']) {
            	that.errorTip = this.$t('mao_global.tip.notPassExamine') + ":" + obj['reFuseReason']
            }
            
            if (that.sForm.ad_Urltype == '1' && obj.appId) {
              var appData = {
                  appName: obj.appName,
                  applicationid: obj.appId
              }             
              
              that.choiceAppRecord(appData)
            }


          })
        } // end if

        axios.post(`${baseurl}/adType/list.do`,{'page':1, rows: 10000}).then(res=>{
          that.adTypeList = res.data.data
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// advert-edit.vue?fe2a93e0